import React from "react";
import { Container } from "react-bootstrap";
import FeatureHeader from "./FeatureHeader/FeatureHeader";
import FeaturePagination from "./FeaturePagination/FeaturePagination";
import classes from "./FeaturePageLayout.module.scss";

const FeaturePageLayout = ({
  t,
  title,
  search,
  selectors,
  table,
  children,
  showCompanySelector,
  selectedCompany,
  onCompanyChange,
  actionButton,
  filters,
  pagination,
}) => {
  return (
    <Container fluid className={`${classes["feature-page-layout"]}`}>
      {title && (
        <FeatureHeader
          t={t}
          title={title}
          search={search}
          showCompanySelector={showCompanySelector}
          selectors={selectors}
          selectedCompany={selectedCompany}
          onCompanyChange={onCompanyChange}
          actionButton={actionButton}
          filterContent={filters}
        />
      )}
      {/* Content section */}
      <div className={classes["feature-content"]}>
        {table}
        {children}
      </div>

      {/* Pagination section */}
      {pagination && pagination.totalPages > 0 && (
        <div className={classes["feature-pagination-container"]}>
          <FeaturePagination
            t={t}
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={pagination.onPageChange}
          />
        </div>
      )}
    </Container>
  );
};

export default FeaturePageLayout;
